export default {
  path: "/news",
  meta: {
    title: "新闻中心",
  },
  component: () => import("@/views/common/moduleMain.vue"),
  children: [
    {
      path: "/company_news/:menuId",
      meta: {
        title: "公司动态",
        contentType: "c-4",
        sortType: "s-201",
      },
      component: () => import("@/views/news/CompanyNews.vue"),
    },
    {
      path: "/party_building/:menuId",
      meta: {
        title: "党建专栏",
        contentType: "c-4",
        sortType: "s-202",
      },
      component: () => import("@/views/news/PartyBuilding.vue"),
    },
    {
      path: "/article_details/:menuId",
      meta: {
        title: "文章详情",
      },
      component: () => import("@/views/news/ArticleDetails.vue"),
    },
  ],
};
